import type { AppState } from 'state/state.model';

import type { FormDataState } from '../formData.model';

const EMPTY: readonly string[] = [];

function getData(state: FormDataState, formId: string): readonly string[] {
  return state?.patchedFields?.[formId] || EMPTY;
}

export function getPatchedFields(state: AppState, formId: string) {
  return getData(state.formData, formId);
}
